































import {
  defineComponent,
  computed,
  watch,
  ref,
  onMounted,
  onUnmounted,
  nextTick,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import _ from 'lodash';
import store from '@/renderer/store';
import storage from '@/renderer/scripts/utils/storage';
import ipc from '@/renderer/scripts/utils/ipc';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';
import smh from '@/renderer/scripts/smh';
import guideHandler from '@/renderer/views/desktop/FileManagement/Workbench/composition/guideHandler';
import { i18n_t } from '@/locales/i18n';
import { FILE_MANAGE_ROUTE_LIST } from '@/renderer/scripts/utils/ConstantConfig';
import GuideStep from './components/GuideStep.vue';
import HelpControls from './components/HelpControls.vue';
import GuideFinished from './components/GuideFinished.vue';

export default defineComponent({
  components: {
    HelpControls,
    GuideFinished,
    GuideStep,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const showHelpControls = ref(false);
    const toggleGuide = ref(false);

    const { workbenchSteps } = sidebarGuideHandler();
    const { methods: guideMethods } = guideHandler();
    const showGuideConfirm = ref(false);
    // 非移动端样式，和有个人空间的情况下才有新手引导
    const hasGuide = computed(
      () => !store.getters.isMobile && !store.getters.isMobileStyle && store.getters.hasPersonalSpace,
    );

    const guideUnFinished = computed(() => {
      const { name } = vm.$route;
      const { baseGuide } = store.getters.noviceGuidance;
      const res =
        (name === 'personalSpace' && !baseGuide?.personalSpace?.done) ||
        (name === 'collaborationSpace' && !baseGuide?.collaborationSpace?.done);
      return res;
    });

    const methods = {
      handleGuide(val: boolean) {
        if (val && showHelpControls.value) {
          showHelpControls.value = false;
        }
        toggleGuide.value = val;
      },
      handleHelp(val: boolean) {
        if (val && toggleGuide.value) {
          toggleGuide.value = false;
        }
        showHelpControls.value = val;
        if (val) showGuideConfirm.value = false;
      },
      guideConfirm() {
        methods.queryNoviceGuidance(true);
      },
      startGuide() {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.START_GUIDE);
        methods.queryNoviceGuidance(false);
        const menuValue = vm.$route.meta?.routerParent || vm.$route.name || '';
        const isShowBaseMenu = FILE_MANAGE_ROUTE_LIST.includes(menuValue);
        nextTick(() => {
          if (!isShowBaseMenu) {
            const admin = [
              {
                id: 'return',
                title: i18n_t('这里进入/退出管理中心'),
                context: i18n_t('统一管理企业员工，企业资产及企业网盘空间。'),
                type: 'goAdmin',
                position: 'right-bottom',
                isAdminPage: true,
              },
            ];
            startGuideSteps(admin);
          } else {
            startGuideSteps(workbenchSteps.value);
          }
        });
      },
      async queryNoviceGuidance(isOpen: boolean) {
        showGuideConfirm.value = isOpen;
        // 发请求修改数据，后续不再展示
        const newOpt = { ...store.getters.noviceGuidance };
        if (!_.isEmpty(newOpt)) {
          if (!newOpt.workbenchTools) {
            newOpt.workbenchTools = {};
          }
          newOpt.workbenchTools.showGuideConfirm = isOpen;
          try {
            await smh.userAPI.createNoviceGuidance(newOpt);
            store.commit('setNoviceGuidance', newOpt);
          } catch (error) {
            logger.ui.error('clickCloseBtn error', error);
          }
        }
      },
    };

    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.SHOW_GUIDE_POPUP, methods.guideConfirm);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.SHOW_GUIDE_POPUP, methods.guideConfirm);
    });
    watch(
      () => store.getters.noviceGuidance,
      val => {
        const { workbenchTools } = val;
        showGuideConfirm.value = workbenchTools?.showGuideConfirm || false;
      },
    );

    watch(
      () => context.root.$route.name,
      val => {
        showHelpControls.value = false;
        const toggleColl = storage.get<boolean>(storage.StoreKey.PACK_UP_COLL_NOVICE_WORK);
        const togglePersonal = storage.get<boolean>(storage.StoreKey.PACK_UP_PERSONAL_NOVICE_WORK);
        const res = (val === 'personalSpace' && togglePersonal) || (val === 'collaborationSpace' && toggleColl);
        toggleGuide.value = res && guideUnFinished.value;
      },
      { immediate: true },
    );

    // onMounted的时候会导致hasPersonalSpace是false，所以监听他为true
    let isLoading = false;
    const unWatch = watch(
      () => store.getters.hasPersonalSpace,
      (val: boolean) => {
        if (!isLoading) {
          if (val && _.isEmpty(store.getters.noviceGuidance)) {
            guideMethods.queryNoviceGuidance();
            isLoading = true;
          }
        } else {
          unWatch?.();
        }
      },
      { immediate: true },
    );

    return { hasGuide, toggleGuide, showGuideConfirm, guideUnFinished, showHelpControls, ...methods };
  },
});
